export default __webpack_public_path__ + "c99aca40b50819d82ca609e55dfdb22e.png";